'use strict';
import Vue from 'vue'
import fa from "vuetify/lib/locale/fa";

function parseUrl(url) {
  const pathAndParams = url.split('?', 2);
  const params = (pathAndParams[1] || "")
    .split('&')
    .map(kv => kv.split('=', 2))
    .filter(kv => kv[1])
    .reduce((obj, kv, i, a) => {
      obj[kv[0]] = kv[1]
      return obj;
    }, {});

  return {
    path: pathAndParams[0],
    params: params
  }
}

export default {
  /**
   * 模块数据列表页面基础功能
   * @param uri 加载数据列表的 URI
   * @returns {*}
   */
  index: function (uri) {
    return {
      // 基础数据项
      data() {
        return {
          loading: false,
          pageResult: {items: [], total: 0}
        }
      },
      // 路由进入前，组件就未完成渲染，不可以使用 this
      beforeRouteEnter(to, from, next) {
        console.log("In Index beforeRouteEnter");
        const parsed = parseUrl(uri);
        const params = xutil.toApiQuery(Object.assign({}, parsed.params, to.query))
        if (Object.keys(params).length == 0) {
          next(vm => {
            vm.loading = false
          })
          return false
        }
        Vue.axios.get(
          parsed.path,
          {
            params: params
          }
        ).then(
          rsp => next(vm => {
            vm.pageResult = rsp.data;
            vm.loading = false

            if (vm.afterGetData) {
              vm.afterGetData(rsp.data)
            }
          })
        )
      },

      // 路由改变前，组件就已经渲染完成，可以使用 this
      beforeRouteUpdate(to, from, next) {
        console.log("In Index beforeRouteUpdate");
        const parsed = parseUrl(uri);
        const params = xutil.toApiQuery(Object.assign({}, parsed.params, to.query))
        if (Object.keys(params).length == 0) {
          this.loading = false;
          next()
          return false
        }
        Vue.axios.get(
          parsed.path,
          {
            params: params
          }
        ).then(
          rsp => {
            this.pageResult = rsp.data;
            this.loading = false;
            if (this.afterGetData) {
              this.afterGetData(rsp.data)
            }
            next()
          }
        )
      },

      // 侦听器
      watch: {
        // 查询条件发生变化时，自动加载数据
        query: {
          deep: true,
          handler: function (val, oldVal) {
            //console.log("In Watch query");
            if (val['totalItems'] === oldVal['totalItems']) {
              const qry = {};
              Object.keys(val).forEach(k => {
                if (k !== 'totalItems') {
                  qry[k] = val[k];
                }
              });
              this.doRoute(qry);
              //console.log("In Watch query doRoute");
              //console.log(qry);
            }
          }
        },
      },
      // 方法
      methods: {
        onEditOk(item) {
          // 刷新列表数据
          if (this.reloadData) {
            // 使route地址发生变化刷新数据
            this.reload = !this.reload
            this.doRoute({reload: this.reload});
            return false;
          }
          if (item) {
            if (!this.editDbid) {
              this.pageResult.items.unshift(item);
            } else {
              const editIdx = this.pageResult.items.findIndex((v, i, a) => v.dbid === item.dbid);
              this.pageResult.items[editIdx] = xutil.clone(item);
            }
          }
        },
        onDeleOk(item) {
          // 刷新列表数据
          if (this.reloadData) {
            // 使route地址发生变化刷新数据
            this.reload = !this.reload
            this.doRoute({reload: this.reload});
            return false;
          }
          if (item) {
            const deleIdx = this.pageResult.items.findIndex((v, i, a) => v.dbid === item.dbid);
            this.pageResult.items.splice(deleIdx, 1);
          }
        },
        clean(query) {
          let q = {};
          Object.keys(query).forEach(k => {
            if (query[k] !== "") {
              q = query[k];
            }
          });
          return q;
        },
        // 根据查询（query）转到新的路由，以便加载数据
        doRoute(query) {
          //console.log(query);
          // this.loading = true;
          // console.log("in doRoute");
          this.$router.push({
            path: this.$route.path,
            query: Object.assign({}, this.$route.query, query)
          });
        }
      }
    };

  },

  /**
   * 模块数据列表页面基础功能
   * @param uri 加载数据列表的 URI
   * @returns {*}
   */
  index_without_pagination: function (uri) {
    return {
      // 基础数据项
      data() {
        return {
          loading: false,
          items: []
        }
      },
      // 路由进入前，组件就未完成渲染，不可以使用 this
      beforeRouteEnter(to, from, next) {
        //console.log("In Index beforeRouteEnter");
        Vue.axios.get(uri, {params: xutil.toApiQuery(to.query)})
          .then(
            rsp => next(vm => {
              vm.items = rsp.data;
              vm.loading = false
            })
          )
      },

      // 路由改变前，组件就已经渲染完成，可以使用 this
      beforeRouteUpdate(to, from, next) {
        //console.log("In Index beforeRouteUpdate");
        Vue.axios.get(uri, {params: xutil.toApiQuery(to.query)})
          .then(
            rsp => {
              this.items = rsp.data;
              this.loading = false;
              next()
            }
          )
      },

      // 侦听器
      watch: {
        // 查询条件发生变化时，自动加载数据
        query: {
          deep: true,
          handler: function (val, oldVal) {
            //console.log("In Watch query");
            if (val['totalItems'] === oldVal['totalItems']) {
              const qry = {};
              Object.keys(val).forEach(k => {
                if (k !== 'totalItems') {
                  qry[k] = val[k];
                }
              });
              this.doRoute(qry);
              //console.log("In Watch query doRoute");
              //console.log(qry);
            }
          }
        },
      },
      // 方法
      methods: {
        onEditOk(item) {
          // console.log("in mixin onEditOK");
          // console.log(item);
          if (item) {
            if (!this.editDbid) {
              this.items.unshift(item);
            } else {
              const editIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
              this.items[editIdx] = xutil.clone(item);
            }
          }
        },
        onDeleOk(item) {
          if (item) {
            const deleIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
            this.items.splice(deleIdx, 1);
          }
        },
        // 根据查询（query）转到新的路由，以便加载数据
        doRoute(query) {
          //console.log(query);
          this.loading = true;
          this.$router.push({
            path: this.$route.path,
            query: Object.assign({}, this.$route.query, query)
          });
        }
      }
    };

  },

  /**
   * 模块查看页面基础功能
   * @param uri 加载数据列表的 URI
   * @returns {*}
   */
  view: function (uri) {
    return {
      props: ['value', 'dbid'],

      // 基础数据项
      data() {
        return {
          loading: false,
          fullscreen: false,
          item: {}
        }
      },

      watch: {
        value(val) {
          val && this.get()
        }
      },

      computed: {
        visible: {
          // getter
          get: function () {
            return this.value;
          },
          // setter
          set: function (nv) {
            this.$emit('input', nv);
          }
        }
      },

      methods: {
        /**
         * **************************************************************
         * 异步数据请求
         */
        get() {
          const vm = this;
          this.loading = true;
          this.axios.get(`${uri}/${this.dbid}`)
            .then(rsp => {
              // 填充对话框
              vm.loading = false;
              vm.item = rsp.data;
              if (this.afterGetData) {
                this.afterGetData(rsp.data)
              }
            });

        }

      }
    };
  },

  edit: function (uri) {
    return {
      props: ['value', 'dbid', "default"],

      // 基础数据项
      data() {
        return {
          loading: false,
          fullscreen: false,

          item: null,
          defaultItem: null,
          freshItem: null,
        }
      },

      mounted() {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        // 复制默认的数据
        this.item = xutil.clone(this.freshItem);
        this.defaultItem = xutil.clone(this.freshItem);
      },

      watch: {
        value(val) {
          if (!val) return;
          if (val && this.onShow) this.onShow()
          this.$refs.formRef.reset();
          this.item = Object.assign(xutil.clone(this.freshItem), this.default || {});
          this.defaultItem = xutil.clone(this.freshItem);

          this.dbid && this.dbid.length > 0 && this.get();
          // dbid 不存在，新建记录
          !this.dbid && this.onNew();
        }
      },

      computed: {
        visible: {
          // getter
          get: function () {
            return this.value;
          },
          // setter
          set: function (nv) {
            this.$emit('input', nv);
          }
        },
        title() {
          return this.dbid ? '编辑' : '新建'
        }
      },

      methods: {
        // 保存响应函数
        onSave() {
          console.log("prepare to save ")
          const vm = this;
          if (this.$refs.formRef.validate()) {
            // 新建
            if (!this.dbid || this.dbid.length === 0) {
              // 以 POST 方式创建新记录
              if (this.beforeSendData) this.beforeSendData(this.item);
              if (this.beforeSaveNewData) this.beforeSaveNewData(this.item);

              vm.loading = true;
              this.axios.post(uri, this.item)
                .then(rsp => {
                  vm.visible = false;
                  vm.$emit('input', false);
                  vm.$emit('ok', this.afterSave ? this.afterSave(rsp.data) : rsp.data);
                  vm.loading = false;
                })
                .catch(ex => {
                  vm.loading = false;
                })
            }
            //保存
            else {
              // 获取修改的字段
              const changes = xutil.changes(this.defaultItem, this.item);

              // 有修改的字段，以 PUT 方式保存修改
              if (Object.keys(changes).length > 0) {
                vm.loading = true;

                if (this.beforeSendData) this.beforeSendData(changes);
                if (this.beforeSaveData) this.beforeSaveData(changes);

                this.axios.put(`${uri}/${this.dbid}`, changes)
                  .then(rsp => {
                    vm.visible = false;
                    //vm.$emit('input', false);
                    vm.$emit('ok', this.afterSave ? this.afterSave(rsp.data) : rsp.data);
                    vm.loading = false;
                  })
              }
              // 关闭对话框
              else {
                vm.visible = false;
                //vm.$emit('input', false);
              }
            }
          } else {
            this.alert = true;
          }
        },
        //新建项目时执行，函数在项目编辑页面自定义
        onNew() {
          if (this.beforNewData) {
            this.beforNewData()
          }
        },
        get() {
          const vm = this;

          if (this.beforeGetData) {
            this.beforeGetData()
          }

          vm.loading = true;
          this.axios.get(`${uri}/${this.dbid}`)
            .then(rsp => {

              // 填充编辑对话框
              vm.item = rsp.data;

              // 保存默认数据
              vm.defaultItem = xutil.clone(vm.item);

              vm.loading = false;

              if (this.afterGetData) {
                this.afterGetData(rsp.data)
              }
            });
        }
      }
    };
  },

  /***
   * 数据页面，不使用windows，加入流程引擎后修改
   * @param uri
   * @returns
   */
  edit_page_fw: function (uri) {
    return {
      // 基础数据项
      data() {
        return {
          loading: true,
          dbid: null,
          item: {}
        }
      },

      computed: {
        title() {
          return this.dbid ? '编辑' : '新建'
        }
      },

      created() {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        // 复制默认的数据
        this.item = xutil.clone(this.freshItem);
        this.defaultItem = xutil.clone(this.freshItem);
        // console.log("In mixin created")
      },

      // 路由进入前，组件就未完成渲染，不可以使用 this
      beforeRouteEnter(to, from, next) {
        console.log("In edit_page beforeRouteEnter");
        const dbid = to.query.dbid;
        const edit = to.query.edit;

        if (dbid) {
          Vue.axios.get(`${uri}${dbid}`)
            .then(
              rsp => next(vm => {
                vm.dbid = dbid;
                // vm.item = xutil.clone(vm.freshItem)
                vm.item = Object.assign({}, vm.freshItem, rsp.data.formJson);
                // 保存默认数据
                vm.defaultItem = xutil.clone(vm.item);
                // 是否处理编辑状态
                vm.edit = edit && rsp.data['acts'] && (rsp.data['acts'].length > 0)
                if (vm["afterGetData"]) {
                  vm.afterGetData(rsp.data)
                }
                vm.loading = false
              })
            )
        } else {
          next(vm => {
            vm.loading = false
            vm.edit = true
            if (vm.beforNewData) {
              vm.beforNewData()
            }
          });
        }
      },

      // 路由改变前，组件就已经渲染完成，可以使用 this
      beforeRouteUpdate(to, from, next) {
        console.log("In edit_page beforeRouteUpdate");
        // 直接修改地址不响应
        this.loading = false;
        next();

        // const dbid = to.query.dbid;
        // if (dbid) {
        //   this.loading = true;
        //   Vue.axios.get(`${uri}${dbid}`)
        //     .then(
        //       rsp => {
        //         this.dbid = dbid;
        //         this.item = rsp.data.formJson;
        //         // 保存默认数据
        //         this.defaultItem = xutil.clone(this.item);
        //         this.loading = false;
        //         next()
        //       }
        //     )
        // } else {
        //   this.loading = false;
        //   next();
        // }
      },

      methods: {
        // 保存响应函数
        onSave() {
          const vm = this;
          let wfId = this.fundId;
          // 新建
          if (!this.dbid) {
            // 以 POST 方式创建新记录
            vm.loading = true;
            const formDate = xutil.clone(this.item);
            if (this.beforeSendData) this.beforeSendData(formDate);
            if (this.beforeSaveNewData) this.beforeSaveNewData(formDate);
            this.axios.post(`${uri}${wfId}`, {formJson: formDate})
              .then(rsp => {
                vm.dbid = rsp.data.dbid;
                vm.loading = false;
                if (this.afterSave) this.afterSave(rsp.data);
              })
          }
          //保存
          else {
            // 获取修改的字段
            const formDate = xutil.clone(this.item);
            vm.loading = true;
            if (this.beforeSendData) this.beforeSendData(formDate);
            if (this.beforeSaveData) this.beforeSaveData(formDate);
            this.axios.put(`${uri}${this.dbid}`, {formJson: formDate})
              .then(rsp => {
                vm.loading = false;
                if (this.afterSave) this.afterSave(rsp.data);
              })
          }
        }
      }
    };
  },

  /**
   * 流程实例列表页面 Mixin
   * @param dataUri 实例数据接口 URI
   * @returns {*}
   */
  wfInstListPage: function (dataUri) {
    return {
      // 基础数据项
      data() {
        return {
          loading: false,

          // 检索条件
          fixedQuery: [],
          instQuery: [],
          formQuery: [],
          formFields: [],
          orderBy: [],

          // 分页信息
          pagination: {
            descending: false,
            page: 1,
            rowsPerPage: 25,
            sortBy: "",
            totalItems: 0
          },
          // 检索结果
          pageResult: {items: [], total: 0}
        }
      },

      // 路由进入前，组件就未完成渲染，不可以使用 this
      beforeRouteEnter(to, from, next) {
        console.log("In Index beforeRouteEnter");
        next(vm => {
            vm.loading = true
            vm.fixedQuery = vm.base64ToJson(to.query['fixedQuery'])
            vm.loadDataPage(to,from)
          }
        )
      },

      // 路由改变前，组件就已经渲染完成，可以使用 this
      beforeRouteUpdate(to, from, next) {
        // console.log("In Index beforeRouteUpdate");
        this.loading = true
        this.fixedQuery = this.base64ToJson(to.query['fixedQuery'])
        // this.loadDataPage()
        next()
      },

      // 离开路由前执行
      beforeRouteLeave(to, from, next) {
        if (this.beforeLeave)
          this.beforeLeave(from,to)
        next()
      },

      // 侦听器
      watch: {
        pagination() {
          // console.log(this.pagination)
          this.loadDataPage()
        }
      },
      // 方法
      methods: {
        base64ToJson(aStr, defaultVal = []) {
          return aStr && aStr.length > 0 ? JSON.parse(atob(aStr)) : defaultVal
        },
        /**
         * 加载一页数据
         */
        loadDataPage(to,from) {
          console.log("in loadDataPage")
          const vm = this
          if (vm.beforeLoadDataPage)
            vm.beforeLoadDataPage(to,from)
          const sortBy = vm.pagination.sortBy ? [
            [vm.pagination.sortBy, !!vm.pagination.descending ? 'desc' : 'asc']
          ] : []
          const data = {
            page: vm.pagination.page - 1,
            limit: vm.pagination.rowsPerPage,
            instQuery: vm.instQuery.concat(vm.fixedQuery).filter(
              it => Array.isArray(it) && it.length === 3 && it[2]
            ),
            formQuery: vm.formQuery.filter(
              it => Array.isArray(it) && it.length === 3 && it[2]
            ),
            formFields: vm.formFields,
            orderBy: vm.orderBy.concat(sortBy)
          }
          vm.loading = true
          this.axios.post(dataUri, data).then(rsp => {
            vm.pageResult = rsp.data;
            vm.pagination.totalItems = rsp.total;
            if (this.afterLoadDatePage)
              this.afterLoadDatePage(vm.pageResult)
          }).finally(() =>
            vm.loading = false
          )
        },

        onDeleOk(item) {
          // 刷新列表数据
          if (this.reloadData) {
            // 使route地址发生变化刷新数据
            this.reload = !this.reload
            this.doRoute({reload: this.reload});
            return false;
          }
          if (item) {
            const deleIdx = this.pageResult.items.findIndex((v, i, a) => v.dbid === item.dbid);
            this.pageResult.items.splice(deleIdx, 1);
          }
        },
        clean(query) {
          let q = {};
          Object.keys(query).forEach(k => {
            if (query[k] !== "") {
              q = query[k];
            }
          });
          return q;
        },
        // 根据查询（query）转到新的路由，以便加载数据
        doRoute(query) {
          // console.log(query);
          // this.loading = true;
          // console.log("in doRoute");
          this.$router.push({
            path: this.$route.path,
            query: Object.assign({}, this.$route.query, query)
          });
        },
        /**
         * 保存页面状态到sessionStorage
         * @param {Object} config - 状态配置
         * @param {Object} stateData - 需要保存的状态数据
         */
        savePageState(config, stateData) {
          if (!config || !config.storageKey) return;

          const state = {
            routerName: config.currentRouteName,
            timestamp: Date.now(),
            ...stateData
          };

          try {
            sessionStorage.setItem(config.storageKey, JSON.stringify(state));
          } catch (e) {
            console.error('Failed to save page state:', e);
          }
        },

        /**
         * 从sessionStorage恢复页面状态
         * @param {Object} config - 状态配置
         * @param {Object} to - 目标路由
         * @param {Object} from - 来源路由
         * @returns {Object|null} 恢复的状态数据
         */
        restorePageState(config, to, from) {
          if (!config || !config.storageKey) return null;

          try {
            const savedState = sessionStorage.getItem(config.storageKey);
            if (!savedState) return null;

            const state = JSON.parse(savedState);

            // 检查状态是否过期（30分钟内有效）
            const isExpired = Date.now() - state.timestamp > 30 * 60 * 1000;
            if (isExpired) {
              sessionStorage.removeItem(config.storageKey);
              return null;
            }

            // 检查路由条件
            const isValidRoute = state.routerName === config.currentRouteName &&
              to.name === config.currentRouteName &&
              from.name === config.editRouteName;

            if (isValidRoute) {
              return state;
            }

            return null;
          } catch (e) {
            console.error('Failed to restore page state:', e);
            sessionStorage.removeItem(config.storageKey);
            return null;
          }
        },

        /**
         * 清除页面状态
         * @param {Object} config - 状态配置
         */
        clearPageState(config) {
          if (config && config.storageKey) {
            sessionStorage.removeItem(config.storageKey);
          }
        },
      }
    };

  }

};



// WEBPACK FOOTER //
// ./src/mixin/index.js